// This file defines the router used in the application
import Vue from "vue";
import VueRouter from "vue-router";
// Import the component pages here
import Home from "./pages/Home";
import Contacts from "./pages/Contacts";
import Cabinets from "./pages/Cabinets";
import PrisesEnCharges from "./pages/PrisesEnCharges";
import RendezVous from "./pages/RendezVous";
import Orthoptie from "./pages/Orthoptie";
import Practiciennes from "./pages/Practiciennes";

// Enable VueRouter
Vue.use(VueRouter);

// Declare the route paths with their associated components
export const routes = [
  { path: "/", component: Home, text: "Accueil" },
  { path: "/orthoptie", text: "L'Orthoptie", component: Orthoptie },
  { path: "/cabinets", text: "Cabinets", component: Cabinets },
  {
    path: "/praticiennes",
    text: "L'équipe",
    component: Practiciennes,
  },
  {
    path: "/consultations",
    text: "Consultations",
    component: PrisesEnCharges,
  },
  { path: "/rendez-vous", text: "Rendez-vous", component: RendezVous },
  { path: "/contact", text: "Contact", component: Contacts },
];

// And create a router object
// Note: History is not the default mode but it is without a doubt the best in term of user experience
export const router = new VueRouter({
  mode: "history",
  routes, // ES2015 shortcut for `routes: routes`
});
